const CACHE_PREFIX = 'route-query-cache';

function getCacheKey (routeName) {
  const tenantId = window.sessionStorage.getItem('tenant-id') || 'default';
  const username = window.sessionStorage.getItem('username') || 'anonymous';
  return `${CACHE_PREFIX}:${tenantId}:${username}:${routeName}`;
}

export function getRouteQueryCache (routeName) {
  try {
    const cache = window.sessionStorage.getItem(getCacheKey(routeName));
    return cache ? JSON.parse(cache) : null;
  } catch (error) {
    return null;
  }
}

export function setRouteQueryCache (routeName, state) {
  try {
    window.sessionStorage.setItem(getCacheKey(routeName), JSON.stringify(state));
  } catch (error) {
    // Query caching should not interrupt normal route navigation.
  }
}
